import DOMPurify from 'dompurify';

const cache = new Map<string, string>();

/**
 * Allowlist allineata all'HTML serializzabile da RichTextBaseExtensions
 * (StarterKit, Underline, TextStyle/Color, SurveyColorStyle, Link,
 * TextAlign): tag fuori lista (es. img, table) vengono rimossi
 * mantenendo il testo contenuto.
 */
const SANITIZE_CONFIG = {
  ALLOWED_TAGS: [
    'p',
    'br',
    'hr',
    'strong',
    'b',
    'em',
    'i',
    'u',
    's',
    'a',
    'span',
    'ul',
    'ol',
    'li',
    'blockquote',
    'code',
    'pre',
    'h1',
    'h2',
    'h3',
    'h4',
    'h5',
    'h6',
  ],
  ALLOWED_ATTR: ['href', 'target', 'rel', 'style', 'class'],
};

/**
 * Sanifica l'HTML con DOMPurify mettendo il risultato in cache, per evitare
 * di ripetere la sanificazione a ogni rerender (es. celle RichText durante
 * la ricerca in tabella). Usa DOMPurify: SOLO browser.
 */
export function cachedSanitizeHtml(html: string): string {
  const cached = cache.get(html);
  if (cached !== undefined) return cached;
  const result = DOMPurify.sanitize(html, SANITIZE_CONFIG);
  cache.set(html, result);
  return result;
}

export function clearSanitizeHtmlCache(): void {
  cache.clear();
}
